import axios from "axios";

import { deleteCookies, clearUserInfo } from "../util/informacoes_usuario";

const secureAxios = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND}/`,
    withCredentials: true
})

secureAxios.interceptors.response.use(
    response => response,
    error => {       
        if (error.response?.data) {
            error.message = error.response.data.message;
            // if (error.response.data.error_code === 4002) {
            //     deleteCookies();
            //     clearUserInfo();
            // }
        } else {
            // Caso contrário, trata como um erro genérico
            console.error('Erro genérico:', error.message || 'Erro desconhecido');
        }
        return Promise.reject(error);
    });

export default secureAxios;
